import React from 'react';
import boardMembersImg from '../images/board-members.webp';
import { SITE_NAME } from '../Constants';

const BoardPage = () => {
    return (
        <>
            <div className='container mx-auto'>
                <section className='py-5 px-4 flex flex-col-reverse lg:flex-row items-center justify-between'>
                    <div className="lg:w-1/2 text-center lg:text-left mt-5">
                        <h1 className='text-xl lg:text-2xl font-bold text-gray-800 mb-6'>Board Members</h1>
                        <p>Name of the office bearers of {SITE_NAME}</p>
                        <ul className='px-5 py-4 list-disc text-left'>
                            <li>Maargadarshee - Shree. Pradeep Nambiar</li>
                            <li>Maargadarshee - Dr. S. Rajesh Kumar</li>
                            <li>Rakshadhikari - Shree. Unnikrishnan Aramana</li>
                            <li>Rakshadhikari - Shree. K. T. Raman</li>
                            <li>President - Shree. V. K. Ramachandran Nair</li>
                            <li>Working President - Dr. K. P. Reghunatha Menon</li>
                            <li>Vice President - Shree. M. R. Ashok Kumar</li>
                            <li>Vice President - Shree. Jayarajan C.</li>
                            <li>General Secretary - Shree. E. S. Anil</li>
                            <li>Joint Secretary - Shree. Rajesh K. K.</li>
                            <li>Organizing Secretary - Shree. P. Santosh</li>
                            <li>Treasurer - Shree. Praveen G.</li>
                            <li>Program Convenor - Shree. Ravindran K.</li>
                            <li>Internal Auditor - Shree. R. Harikrishnan</li>
                            <li>Executive Member - Shree. V. M. Madhavan Nampoothiri</li>
                            <li>Executive Member - Shree. P. Satheesh Kumar</li>
                            <li>Executive Member - Shree. J. S. Pillai</li>
                            <li>Executive Member - Shree. K. N. Gangadharan</li>
                            <li>Executive Member - Shree. Anil Kumar G</li>
                            <li>Executive Member - Shree. Vinod P.</li>
                            <li>Executive Member - Shree Anandhu T.</li>
                            <li>Executive Member - Shree Ramesh Kumar G</li>
                            <li>Executive Member - Shree T. E. Prasannan</li>
                        </ul>
                    </div>
                    <div className="lg:w-1/2">
                        <img
                            src={boardMembersImg}
                            alt='Board Members'
                            className="rounded-lg shadow-lg object-cover"
                        />
                    </div>
                </section>
            </div>
        </>
    );
};

export default BoardPage;